/// <reference types="../types/images" />
import flag_se from "../assets/icons/flags/se.svg";
import flag_dk from "../assets/icons/flags/dk.svg";
import flag_fi from "../assets/icons/flags/fi.svg";
import flag_no from "../assets/icons/flags/no.svg";
import flag_hr from "../assets/icons/flags/hr.svg";
import flag_gb from "../assets/icons/flags/gb.svg";
import flag_de from "../assets/icons/flags/de.svg";
import flag_nl from "../assets/icons/flags/nl.svg";
import flag_fr from "../assets/icons/flags/fr.svg";
import flag_us from "../assets/icons/flags/us.svg";
import flag_en from "../assets/icons/flags/en.svg";
import flag_es from "../assets/icons/flags/es.svg";
import flag_it from "../assets/icons/flags/it.svg";
import flag_zh from "../assets/icons/flags/zh.svg";

import { getI18n } from "react-i18next";

export function getTranslationFunction(namespace = "Bjelin") {
  return getI18n().getFixedT(getI18n().language, namespace);
}

export const flags: { [key: string]: string } = {
  sv: flag_se,
  da: flag_dk,
  fi: flag_fi,
  no: flag_no,
  hr: flag_hr,
  en: flag_en,
  fr: flag_fr,
  it: flag_it,
  es: flag_es,
  de: flag_de,
  nl: flag_nl,
  uk: flag_gb,
  us: flag_us,
  "en-us": flag_us,
  zh: flag_zh
};

export function getFlag(site: string, lang: string) {
  if (site === "uk" && lang === "en") return flags["uk"];
  if (site === "us" && (lang === "en" || lang === "en-us")) return flags["us"];
  return flags[lang];
}
